import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomTest, QuestionSchema, TestGroup } from '../models/custom_test_model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class CustomTestService {

  constructor(
    private http: HttpClient
  ) { }

  createTestGroup(testGroup: TestGroup): Observable<TestGroup>{
    return this.http.post<TestGroup>(`${environment.apiBaseUrl}/customTests/createTestGroup`, testGroup);
  }

  updateTestGroup(data: Partial<TestGroup>, id: string): Observable<TestGroup>{
    let obj = {
      ...data,
      _id: id
    }
    return this.http.put<TestGroup>(`${environment.apiBaseUrl}/customTests/updateTestGroup`, obj);
  }

  getTestGroups(query: object): Observable<TestGroup[]>{
    return this.http.post<TestGroup[]>(`${environment.apiBaseUrl}/customTests/getTestGroups`, query);
  }

  deleteTestGroup(id: string): Observable<any>{
    return this.http.delete<any>(`${environment.apiBaseUrl}/customTests/deleteTestGroup/${id}`);
  }

  createCustomTest(customTest: CustomTest): Observable<TestGroup>{
    return this.http.post<TestGroup>(`${environment.apiBaseUrl}/customTests/createCustomTest`, customTest);
  }

  updateCustomTest(data: Partial<CustomTest>, id: string): Observable<TestGroup>{
    let obj = {
      ...data,
      _id: id
    }
    return this.http.put<TestGroup>(`${environment.apiBaseUrl}/customTests/updateCustomTest`, obj);
  }

  deleteCustomTest(id: string): Observable<any>{
    return this.http.delete<any>(`${environment.apiBaseUrl}/customTests/deleteCustomTest/${id}`);
  }

  getCustomTests(query: object): Observable<CustomTest[]>{
    return this.http.post<CustomTest[]>(`${environment.apiBaseUrl}/customTests/getCustomTests`, query);
  }

  updateTestQuestion(testId: string, question: QuestionSchema): Observable<CustomTest>{
    let obj = {
      testId,
      question
    }
    return this.http.put<CustomTest>(`${environment.apiBaseUrl}/customTests/updateTestQuestion`, obj);
  }

  deleteTestQuestion(testId: string, questionId: string): Observable<CustomTest>{
    let obj = {
      testId,
      questionId
    }
    return this.http.post<CustomTest>(`${environment.apiBaseUrl}/customTests/deleteTestQuestion`, obj);
  }

  updateTestQuestionOrder(testId: string, index1: number, index2: number): Observable<CustomTest>{
    let obj = {
      testId,
      index1,
      index2
    }
    return this.http.post<CustomTest>(`${environment.apiBaseUrl}/customTests/updateTestQuestionsOrder`, obj);
  }



  

}
